import React from 'react'
import { Paper, Typography } from '@mui/material'
import useThemeMode from '../../hooks/useThemeMode'

interface StatCardProps {
  label: string
  value: React.ReactNode
  hint?: React.ReactNode
}

const StatCard = ({ label, value, hint }: StatCardProps) => {
  const { isDark } = useThemeMode()

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
        borderRadius: '12px',
        p: { xs: 2, sm: 2.5 },
        height: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: '11px', sm: '12px' },
          fontWeight: 600,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        noWrap
        sx={{
          fontSize: { xs: '18px', sm: '22px' },
          fontWeight: 700,
          color: 'text.primary',
          lineHeight: 1.2,
          textTransform: 'capitalize',
        }}
      >
        {value}
      </Typography>
      {hint != null && hint !== false && (
        <Typography sx={{ fontSize: '12px', color: 'text.secondary', mt: 0.5 }}>{hint}</Typography>
      )}
    </Paper>
  )
}

export default StatCard
